/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { CreditorModelDto, SearchCreditorsRequestDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class CreditorsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * @description This endpoint supports filtering by: BeneficiaryName, Status (Pending / Approved / Rejected), Country, BankId, BankName, CreatedDate ranges, and BeneficiaryType (Domestic / International / Both). RequireEntitlement flag further limits the result set when true.
   *
   * @tags Creditors
   * @name CreditorsSearch
   * @summary Searches for Creditors that match the criteria supplied in searchCreditorsRequest.
   * @request POST:/creditors/search
   */
  creditorsSearch = (
    data: SearchCreditorsRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<CreditorModelDto[], any>({
      path: `/creditors/search`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description On success, the returned model may contain additional information such as audit fields or approval requirements.
   *
   * @tags Creditors
   * @name CreditorsPost
   * @summary Creates a new Creditor resource.
   * @request POST:/creditors
   */
  creditorsPost = (data: CreditorModelDto, params: RequestParams = {}) =>
    this.http.request<CreditorModelDto, any>({
      path: `/creditors`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description If approval workflow applies, the response may represent a pending state rather than an immediately active record.
   *
   * @tags Creditors
   * @name CreditorsPut
   * @summary Updates an existing Creditor resource.
   * @request PUT:/creditors
   */
  creditorsPut = (data: CreditorModelDto, params: RequestParams = {}) =>
    this.http.request<CreditorModelDto, any>({
      path: `/creditors`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
